// A shared guide link carries a `sharedToken` query param, forwarded as the
// "Shared-Token" header on the backend's /shared/* endpoints. The token
// itself is generated/issued elsewhere; this app only needs to read
// whichever value is in the URL and forward it — validity is the backend's
// concern (an invalid token 401s, which routes the user to /login as usual).
export const SHARED_TOKEN_HEADER = "Shared-Token";
export const SHARED_TOKEN_QUERY_PARAM = "sharedToken";
